export function isValidHttpUrl(url) {
  if (!url) return false;

  const trimmed = url.trim();

  return (
    trimmed.startsWith("http://") ||
    trimmed.startsWith("https://")
  );
}

export function normalizeUrl(url) {
  return url.trim();
}
